/** מפתח Maps JavaScript בדפדפן — מתואם ל־weme-app; override עם `VITE_GOOGLE_MAPS_API_KEY` ב־`.env`. */
export const GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "AIzaSyCPc0YyYE1K9UOdVbftFTAccsxNFhrDA5k";

export const GOOGLE_MAPS_LIBRARIES = ["places"];
export const GOOGLE_MAPS_STATISTICS_LIBRARIES = ["places"];
export const GOOGLE_MAPS_LANGUAGE = "he";
export const GOOGLE_MAPS_REGION = "IL";
